import { frontendURL } from '../../../helper/URLHelper';
import Wrapper from './Wrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wgpt-custom-app'),
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: Wrapper,
      children: [
        {
          path: ':customAppId',
          name: 'wgpt_custom_app_item',
          component: Index,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
